/*
  Edycja konfiguracji dywaników bezpośrednio w koszyku (CRO, pkt 5 ТЗ).
  Zakres: Rodzaj + Zestaw (wariant produktu), Kształt komórek, Kolor materiału, Kolor obszycia.

  Interfejs: lista wybranych opcji. Wszystkie kroki są zwinięte i pokazują próbkę
  z aktualną wartością. Ołówek otwiera jeden krok; wybór NIE przewija dalej —
  krok zamyka dopiero przycisk „Gotowe”. Potem można otworzyć kolejny krok.

  Dane opcji: snippets/eva-config-data.liquid  (<script id="eva-config-catalog">)
  Warianty i ceny: /products/<handle>.js
  Stan pozycji koszyka: /cart.js  (klucz linii = data-line-key na wierszu)

  Po zapisie wywołujemy cart-items.updateQuantity(), żeby użyć istniejącej logiki motywu:
  synchronizacji dopłaty "Kształt komórek - Krople" (+100 zł) oraz gratisowego Tunelu,
  a także przerysowania sekcji koszyka.
*/
(function () {
  'use strict';

  var IS_EN = /^en(?:-|$)/i.test(document.documentElement.lang || '');

  function tr(pl, en) {
    return IS_EN ? en : pl;
  }

  /* Wartości wariantów i właściwości koszyka pozostają po polsku, bo na nich
     opiera się dopasowanie wariantów. Tłumaczymy wyłącznie warstwę widoczną. */
  function localizeUiValue(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!IS_EN || !raw) return raw;
    var suffix = '';
    var base = raw.replace(/\s*(\([+−-]?\s*\d[^)]*\))\s*$/, function (_, found) {
      suffix = ' ' + found;
      return '';
    });
    var map = {
      'rodzaj dywaników': 'Mat type',
      'rodzaj dywanikow': 'Mat type',
      'zestaw': 'Set',
      'kształt komórek': 'Cell pattern',
      'ksztalt komorek': 'Cell pattern',
      'kolor materiału': 'Mat colour',
      'kolor materialu': 'Mat colour',
      'kolor obszycia': 'Trim colour',
      'kolor': 'Colour',
      'rozmiar': 'Size',
      'montaż': 'Installation',
      'montaz': 'Installation',
      'podpiętka': 'Heel pad',
      'podpietka': 'Heel pad',
      'dodatki': 'Extras',
      'nie wybrano': 'Not selected',
      'zamontowana': 'Installed',
      'niezamontowana': 'Not installed',
      'romby': 'Diamonds',
      'plaster miodu': 'Honeycomb',
      'krople': 'Droplets',
      'czarny': 'Black',
      'brązowy': 'Brown',
      'brazowy': 'Brown',
      'ciemnoszary': 'Dark Grey',
      'ciemny szary': 'Dark Grey',
      'granatowy': 'Navy Blue',
      'niebieski': 'Blue',
      'zielony': 'Green',
      'czerwony': 'Red',
      'bordowy': 'Maroon',
      'jasnobeżowy': 'Light Beige',
      'jasnobezowy': 'Light Beige',
      'beżowy': 'Beige',
      'bezowy': 'Beige',
      'fioletowy': 'Purple',
      'jasnozielony': 'Light Green',
      'żółty': 'Yellow',
      'zolty': 'Yellow',
      'pomarańczowy': 'Orange',
      'pomaranczowy': 'Orange',
      'kość słoniowa': 'Ivory',
      'kosc sloniowa': 'Ivory',
      'różowy': 'Pink',
      'rozowy': 'Pink',
      'biały': 'White',
      'bialy': 'White',
      'jasnoszary': 'Light Grey',
      'malinowy': 'Raspberry',
      'miedziany': 'Copper',
      'przód': 'Front',
      'przod': 'Front',
      'tył': 'Rear',
      'tyl': 'Rear',
      'przód + tył': 'Front + Rear',
      'przod + tyl': 'Front + Rear',
      'przod + bagaznik': 'Front + Boot Mat',
      'przod + tyl + bagaznik': 'Front + Rear + Boot Mat',
      'przod + tyl + duzy bagaznik': 'Front + Rear + Large Trunk Mat',
      'przod + tyl + 3 rzad': 'Front + Rear + Third Row',
      'przod + tyl + 3 rzad + maly bagaznik': 'Front + Rear + Third Row + Small Trunk Mat',
      'przod + tyl + 3 rzad + duzy bagaznik': 'Front + Rear + Third Row + Large Trunk Mat',
      'mata do bagażnika': 'Trunk Mat',
      'mata do bagaznika': 'Trunk Mat',
      'mata do bagaznika wersja benzyna': 'Trunk Mat — Petrol Version',
      'duza mata do bagaznika': 'Large Trunk Mat',
      'bagaznik': 'Trunk Mat',
      'dywanik kierowcy': "Driver's Mat",
      'dywanik pasazera': "Passenger's Mat",
      '1 rzad': '1 Row',
      '1 rzad + bagaznik': '1 Row + Trunk Mat',
      '2 rzad': 'Second Row',
      '2 rzedy': '2 Rows',
      '2 rzedy + bagaznik': '2 Rows + Trunk Mat',
      '2 rzedy + duzy bagaznik': '2 Rows + Large Trunk Mat',
      '3 rzedy': '3 Rows',
      'bagaznik maly': 'Small Boot Mat',
      'bagaznik duzy': 'Large Boot Mat',
      '3 rzedy + bagaznik maly': '3 Rows + Small Boot',
      '3 rzedy + bagaznik duzy': '3 Rows + Large Boot',
      '3 rzedy+ bagaznik duzy (cale auto)': '3 Rows + Large Boot (Whole Vehicle)',
      '3 rzedy + bagaznik duzy (cale auto)': '3 Rows + Large Boot (Whole Vehicle)',
      '3 rzedy + 2 bagazniki maly i duzy(cale auto)': '3 Rows + Small And Large Boot (Whole Car)',
      '3 rzedy + 2 bagazniki maly i duzy (cale auto)': '3 Rows + Small And Large Boot (Whole Car)',
      '3 rzedy + 2 bagazniki (maly i duzy) (cale auto)': '3 Rows + Small And Large Boot (Whole Car)',
      '3 rzędy + 2 bagażniki (duży i mały)': '3 rows + 2 boot mats (large and small)',
      '3 rzedy + 2 bagazniki (duzy i maly)': '3 rows + 2 boot mats (large and small)',
      '3 rzedy + 2 bagazniki (duzy | maly)': 'Three Rows + Two Trunk Mats (Large | Small)',
      '3 rzedu + 2 bagazniki': 'Three Rows + Two Trunk Mats (Large | Small)',
      '3 rows 2 trunks': 'Three Rows + Two Trunk Mats (Large | Small)',
      'przod bez tunelu': 'Front Without Tunnel',
      'przod z tunelem': 'Front With Tunnel',
      'przod + tyl + 3 bagazniki (1 duzy i 2 malych z przodu i z tylu)': 'Front + Rear + 3 Trunk Mats (1 Large + 2 Small)',
      '2 rzedy + 3 bagazniki (1 duzy i 2 malych z przodu i z tylu)': '2 Rows + 3 Trunk Mats (1 Large + 2 Small)',
      'przod + tyl + 3 rzad + 3 bagazniki (1 maly bagaznik i 2 malych z przodu i z tylu)': 'Front + Rear + Third Row + 3 Small Trunk Mats',
      'przod + tyl + 3 rzad + 3 bagazniki (1 duzy bagaznik i 2 malych z przodu i z tylu)': 'Front + Rear + Third Row + 3 Trunk Mats (1 Large + 2 Small)',
      '3d bez rantów': '3D without raised edges',
      '3d bez rantow': '3D without raised edges',
      '3d z rantami': '3D with raised edges',
      '3d z jęzorem': '3D with tongue',
      '3d z jezorem': '3D with tongue'
    };
    var key = norm(base);
    return (map[key] || base) + suffix;
  }

  var PROP_SHAPE = 'Ksztalt komorek';
  var PROP_MAT = 'Kolor materialu';
  var PROP_TRIM = 'Kolor obszycia';

  var catalog = null;
  var discountCampaigns = null;
  var discountConfigFound = false;
  var sheet = null;
  var state = null;

  function createConfigId() {
    return 'cfg_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function getCatalog() {
    if (catalog) return catalog;
    var el = document.getElementById('eva-config-catalog');
    if (!el) return null;
    try {
      catalog = JSON.parse(el.textContent);
    } catch (e) {
      console.error('[cart-config-edit] nie udało się sparsować katalogu opcji', e);
    }
    return catalog;
  }

  /* Uwaga: „ł” nie ma diakrytyku łączącego — NFD jej nie rozkłada, więc bez osobnego
     mapowania „tył” nie zrównałoby się z kluczem „tyl” w katalogu. */
  function norm(value) {
    return (value == null ? '' : String(value))
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[łŁ]/g, 'l')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }


  /* Sciezka do plikow sklepu: wyciagamy ja z dowolnego obrazka katalogu opcji,
     zeby nie zaszywac domeny CDN na sztywno. */
  var FILE_BASE = (function () {
    try {
      var cat = JSON.parse(document.getElementById('eva-config-catalog').textContent);
      var any = (cat.shapes && cat.shapes[0] && cat.shapes[0].img) || '';
      return any ? any.slice(0, any.lastIndexOf('/') + 1) : '';
    } catch (e) { return ''; }
  })();

  /* Zdjecie rodzaju dywanikow — te same grafiki, co w konfiguratorze na karcie produktu. */
  function typeImage(value) {
    var s = String(value || '').toLowerCase();
    var file = '';
    if (s.indexOf('jezor') !== -1 || s.indexOf('j\u0119zor') !== -1) file = '5os-tongue-diamonds-black-red.webp';
    else if (s.indexOf('bez rant') !== -1) file = '5os-classic-diamonds-black-red.webp';
    else if (s.indexOf('rant') !== -1) file = '5os-3d-diamonds-black-red.webp';
    return file ? FILE_BASE + file : null;
  }


  /* ──────────────────────────────────────────────────────────────────────
     Podpietka i dodatki.
     To NIE sa czesci kompletu dywanikow — trafiaja do koszyka jako osobne
     pozycje. Katalog renderuje Liquid (script#eva-addons-catalog), wiec lista
     zawsze zgadza sie z katalogiem sklepu i nie robimy zapytan z przegladarki.
     ────────────────────────────────────────────────────────────────────── */
  var ADDONS = (function () {
    try {
      return JSON.parse(document.getElementById('eva-addons-catalog').textContent);
    } catch (e) { return { podpietki: [], dodatki: [] }; }
  })();

  /* ──────────────────────────────────────────────────────────────────────
     Stan dodatkow. Zrodlem prawdy jest KOSZYK: co lezy w koszyku, to jest
     zaznaczone. Usuniecie pozycji z koszyka od razu odznacza ja w popupie,
     a zapis nie duplikuje pozycji — podmienia ja.
     Warianty pokazujemy GRUPAMI OPCJI (Kolor swatchami, reszta chipsami),
     dokladnie tak jak na karcie produktu, a nie plaska lista kombinacji.
     ────────────────────────────────────────────────────────────────────── */
  var pendingStep = null;
  var addonOn = {};      /* handle -> true            (podpietka: max jeden) */
  var addonSel = {};     /* handle -> [wartosci opcji] */
  var addonInCart = {};  /* handle -> {key, id, qty}  */

  function allAddons() {
    return (ADDONS.podpietki || []).concat(ADDONS.dodatki || []);
  }
  function addonVariants(p) {
    return (p.variants && p.variants.length) ? p.variants : [{ id: p.variantId, title: '', price: p.price, opts: [] }];
  }
  function defaultValues(p) {
    var v0 = addonVariants(p)[0];
    return (v0.opts && v0.opts.length) ? v0.opts.slice() : [];
  }
  function valuesOf(p) {
    if (!addonSel[p.handle]) addonSel[p.handle] = defaultValues(p);
    return addonSel[p.handle];
  }
  /* wariant pasujacy do wybranych wartosci; gdy kombinacja nie istnieje — najblizszy */
  function variantFor(p, vals) {
    var vs = addonVariants(p);
    if (!vals || !vals.length) return vs[0];
    var exact = vs.filter(function (v) {
      return (v.opts || []).every(function (o, i) { return o === vals[i]; });
    })[0];
    if (exact) return exact;
    var best = null, bestScore = -1;
    vs.forEach(function (v) {
      var score = (v.opts || []).reduce(function (a, o, i) { return a + (o === vals[i] ? 1 : 0); }, 0);
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best || vs[0];
  }
  function currentVariant(p) {
    return variantFor(p, valuesOf(p));
  }

  /* grupy opcji — uklad 1:1 z karta produktu */
  function optionGroups(p) {
    if (!p.options || !p.options.length) return '';
    if (p.options.length === 1 && p.options[0].values.length < 2) return '';
    var vals = valuesOf(p);
    return (
      '<div class="cfg-addon__opts">' +
      p.options.map(function (o, oi) {
        /* Po angielsku opcja nazywa sie 'Colour' — probki maja byc w obu jezykach (wlasciciel 15.09).
           Liquid daje "hex" wlasnie opcji koloru, wiec jego obecnosc tez rozstrzyga. */
        var isColor = /^(kolor|colou?r)$/.test(norm(o.name)) || o.values.some(function (v) { return !!v.hex; });
        var chips = o.values.map(function (val) {
          var sel = vals[oi] === val.v;
          var nm = 'cfg-opt::' + p.handle + '::' + oi;
          if (isColor) {
            return (
              '<label class="cfg-opt cfg-opt--swatch' + (sel ? ' is-selected' : '') + '" title="' + escapeAttr(localizeUiValue(val.v)) + '">' +
              '<input type="radio" name="' + escapeAttr(nm) + '" value="' + escapeAttr(val.v) + '"' + (sel ? ' checked' : '') + '>' +
              '<i style="background:' + escapeAttr(val.hex || '#ccc') + '"></i>' +
              '</label>'
            );
          }
          return (
            '<label class="cfg-opt cfg-opt--chip' + (sel ? ' is-selected' : '') + '">' +
            '<input type="radio" name="' + escapeAttr(nm) + '" value="' + escapeAttr(val.v) + '"' + (sel ? ' checked' : '') + '>' +
            '<span>' + escapeHtml(localizeUiValue(val.v)) + '</span>' +
            '</label>'
          );
        }).join('');
        return (
          '<div class="cfg-optgroup">' +
          '<span class="cfg-optgroup__label">' + escapeHtml(localizeUiValue(o.name)) +
          (isColor ? ': <b>' + escapeHtml(localizeUiValue(vals[oi] || '')) + '</b>' : '') + '</span>' +
          '<div class="cfg-optgroup__row">' + chips + '</div>' +
          '</div>'
        );
      }).join('') +
      '</div>'
    );
  }

  function addonRow(p, name, type) {
    var checked = !!addonOn[p.handle];
    var cur = currentVariant(p);
    return (
      '<div class="cfg-addon' + (checked ? ' is-selected' : '') + '" data-addon-handle="' + escapeAttr(p.handle) + '">' +
      '<label class="cfg-row cfg-row--img' + (checked ? ' is-selected' : '') + '">' +
      '<input type="' + type + '" name="' + name + '" value="' + escapeAttr(p.handle) + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="cfg-row__img"><img src="' + (p.img || '') + '" alt="" decoding="async" width="56" height="56"></span>' +
      '<span class="cfg-row__body">' +
      '<span class="cfg-row__name">' + escapeHtml(localizeUiValue(p.title)) + '</span>' +
      (p.note ? '<span class="cfg-row__note">' + escapeHtml(localizeUiValue(p.note)) + '</span>' : '') +
      '</span>' +
      '<span class="cfg-row__price">' + money(cur.price) + '</span>' +
      '</label>' +
      (checked ? optionGroups(p) : '') +
      '</div>'
    );
  }


  /* ── Zamontowana moze byc tylko jedna podpietka ───────────────────────────
     Montaz to usluga wykonywana w jednym aucie, wiec druga zamontowana nie ma
     sensu. Zamiast blokowac wybor, cicho przestawiamy poprzednia na
     „Niezamontowana” — klient dostaje to, co chcial, i traci doplate 10 zl. */
  function jestZamontowana(p, vals) {
    if (!p.options || !vals) return false;
    for (var i = 0; i < p.options.length; i++) {
      var nazwa = (p.options[i].name || '').toLowerCase();
      if (nazwa.indexOf('monta') === 0 || nazwa.indexOf('montaz') > -1 || nazwa.indexOf('montaż') > -1) {
        return /zamontowana/i.test(vals[i] || '') && !/niezamontowana/i.test(vals[i] || '');
      }
    }
    return false;
  }
  function odmontujPozostale(pomijHandle) {
    (ADDONS.podpietki || []).forEach(function (p) {
      if (p.handle === pomijHandle) return;
      var vals = addonSel[p.handle];
      if (!vals || !jestZamontowana(p, vals)) return;
      for (var i = 0; i < p.options.length; i++) {
        var nazwa = (p.options[i].name || '').toLowerCase();
        if (nazwa.indexOf('monta') > -1) {
          var bez = (p.options[i].values || []).filter(function (x) { return /niezamontowana/i.test(x.v); })[0];
          if (bez) {
            var kopia = vals.slice();
            kopia[i] = bez.v;
            addonSel[p.handle] = (variantFor(p, kopia).opts || kopia).slice();
          }
        }
      }
    });
  }

  function pickedPodpietkaProduct() {
    return (ADDONS.podpietki || []).filter(function (x) { return addonOn[x.handle]; })[0] || null;
  }
  function pickedDodatkiProducts() {
    return (ADDONS.dodatki || []).filter(function (x) { return addonOn[x.handle]; });
  }
  function addonSummary() {
    var out = [];
    var pp = (ADDONS.podpietki || []).filter(function (x) { return addonOn[x.handle]; });
    if (pp.length === 1) out.push(localizeUiValue(pp[0].title));
    else if (pp.length > 1) out.push(pp.length + tr(' podpiętki', ' heel pads'));
    var dd = pickedDodatkiProducts();
    if (dd.length) out.push(dd.length + (dd.length === 1 ? tr(' dodatek', ' extra') : tr(' dodatki', ' extras')));
    return out.length ? out.join(' · ') : tr('Nie wybrano', 'Not selected');
  }

  /* KOSZYK -> zaznaczenia; wolane przy kazdym otwarciu popupu.
     `myConfigId` to identyfikator kompletu, ktory wlasnie edytujemy. Gdy pozycje
     go maja, bierzemy pod uwage wylacznie dodatki tego kompletu — inaczej przy
     dwoch kompletach popup pokazywal cudza podpietke jako wybrana, a jej
     odznaczenie kasowalo ja z drugiej karty. Pozycje bez identyfikatora
     (stare koszyki) traktujemy po staremu, czyli wspolnie. */
  function syncAddonsFromCart(cart, myConfigId) {
    addonOn = {};
    addonInCart = {};
    var byId = {};
    allAddons().forEach(function (p) {
      addonVariants(p).forEach(function (v) { byId[v.id] = { p: p, v: v }; });
    });
    var anyHasCfg = (cart.items || []).some(function (it) {
      return it.properties && it.properties._config_id;
    });
    (cart.items || []).forEach(function (it) {
      var hit = byId[it.variant_id];
      if (!hit) return;
      if (anyHasCfg) {
        var cfg = it.properties && it.properties._config_id;
        /* Nowa karta czyta tylko swoja grupe. Stara, jeszcze niezmigrowana
           karta moze widziec jedynie stare dodatki bez ID — nigdy dodatki
           nalezace juz do innego kompletu. */
        if (myConfigId ? cfg !== myConfigId : !!cfg) return;
      }
      addonOn[hit.p.handle] = true;
      addonSel[hit.p.handle] = (hit.v.opts && hit.v.opts.length) ? hit.v.opts.slice() : defaultValues(hit.p);
      addonInCart[hit.p.handle] = { key: it.key, id: it.variant_id, qty: it.quantity };
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function displayValue(value) {
    return String(value == null ? '' : value).split('#MWS')[0].trim();
  }

  /* Nazwy w katalogu są WERSALIKAMI (podpisy próbek). W nagłówku kroku czytelniejsze jest Zdanie. */
  function pretty(value) {
    var text = String(value == null ? '' : value).trim();
    if (IS_EN) return localizeUiValue(text);
    if (!text || text !== text.toUpperCase()) return text;
    return text.charAt(0) + text.slice(1).toLowerCase();
  }

  function escapeAttr(value) {
    return String(value == null ? '' : value).replace(/"/g, '&quot;');
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' → ' + r.status);
      return r.json();
    });
  }

  /* Discount Mixer umieszcza aktywne kampanie w JSON-ie strony. Czytamy to samo
     zrodlo co koszyk, dzieki czemu podglad nie musi na chwile zmieniac koszyka. */
  function getDiscountCampaigns() {
    if (discountCampaigns) return discountCampaigns;
    var el = document.querySelector('[data-dmixer-config="storefront"]');
    if (!el) return [];
    try {
      var config = JSON.parse(el.textContent);
      discountConfigFound = true;
      discountCampaigns = (config.campaigns && config.campaigns.product) || [];
    } catch (e) {
      console.warn('[cart-config-edit] nie udało się odczytać kampanii rabatowych', e);
      discountCampaigns = [];
    }
    return discountCampaigns;
  }

  function idOnList(list, id) {
    return String(list || '').split(',').some(function (entry) {
      return entry.trim() === String(id);
    });
  }

  function discountPercentFor(variant) {
    var campaigns = getDiscountCampaigns();
    var id = variant && variant.id;
    var price = variant ? Number(variant.price) / 100 : 0;
    var exact = campaigns.filter(function (campaign) {
      return campaign && campaign.t === 'P' && campaign.f && idOnList(campaign.f.vi, id);
    }).sort(function (a, b) { return (Number(b.pr) || 0) - (Number(a.pr) || 0); })[0];
    if (exact) return Number(exact.d) || 0;

    var ranged = campaigns.filter(function (campaign) {
      if (!campaign || campaign.t !== 'P' || !campaign.f) return false;
      if (campaign.f.vi || (campaign.f.l == null && campaign.f.h == null)) return false;
      if (campaign.e && idOnList(campaign.e.vi, id)) return false;
      if (campaign.f.l != null && price < Number(campaign.f.l)) return false;
      if (campaign.f.h != null && price > Number(campaign.f.h)) return false;
      return true;
    }).sort(function (a, b) { return (Number(b.pr) || 0) - (Number(a.pr) || 0); })[0];
    if (ranged) return Number(ranged.d) || 0;

    /* Awaryjnie zachowujemy potwierdzona tabele sklepu, gdy blok aplikacji
       zostanie doladowany pozniej. Gdy JSON jest obecny, brak reguly oznacza 0%. */
    if (!discountConfigFound) {
      if (price >= 910) return 30;
      if (price >= 290 && price <= 900) return 20;
    }
    return 0;
  }

  function variantPricing(variant, quantity) {
    var regular = (Number(variant.price) || 0) * (quantity || 1);
    var percent = discountPercentFor(variant);
    return {
      regular: regular,
      final: Math.round(regular * (100 - percent) / 100),
      percent: percent
    };
  }

  function variantPriceHtml(variant) {
    var pricing = variantPricing(variant, 1);
    if (pricing.final >= pricing.regular) {
      return '<span class="cfg-row__price">' + money(pricing.regular) + '</span>';
    }
    return (
      '<span class="cfg-row__price cfg-row__price--sale">' +
      '<s>' + money(pricing.regular) + '</s>' +
      '<strong>' + money(pricing.final) + '</strong>' +
      '<small>-' + pricing.percent + '%</small>' +
      '</span>'
    );
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || url + ' → ' + r.status);
        return data;
      });
    });
  }

  function cleanProps(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (!k || props[k] === null || props[k] === undefined) return;
      out[k] = String(props[k]);
    });
    return out;
  }

  /* change.js bywa kaprysne przy `id` = klucz linii (szczegolnie po zmianie
     skladnikow koszyka). Numer linii z aktualnego /cart.js jest jednoznaczny. */
  function findCartItem(cart, hint) {
    var items = (cart && cart.items) || [];
    var i;
    if (hint && hint.key) {
      for (i = 0; i < items.length; i += 1) {
        if (items[i].key === hint.key) return { item: items[i], line: i + 1 };
      }
    }
    if (hint && hint.configId) {
      for (i = 0; i < items.length; i += 1) {
        var p = items[i].properties || {};
        if (p._config_id === hint.configId && p._role !== 'heel' && p._role !== 'extra' && p._role !== 'drop') {
          return { item: items[i], line: i + 1 };
        }
      }
    }
    if (hint && hint.variantId) {
      for (i = 0; i < items.length; i += 1) {
        if (Number(items[i].variant_id) === Number(hint.variantId)) {
          return { item: items[i], line: i + 1 };
        }
      }
    }
    return null;
  }

  function changeLine(line, quantity, properties) {
    var body = { line: Number(line), quantity: Number(quantity) };
    if (properties) body.properties = cleanProps(properties);
    return postJSON('/cart/change.js', body);
  }

  function shapeByValue(value) {
    var data = getCatalog();
    if (!data) return null;
    var needle = norm(value);
    return (
      data.shapes.filter(function (s) {
        return norm(s.value) === needle;
      })[0] || null
    );
  }

  function colorByValue(list, value) {
    var needle = norm(value);
    return (
      (list || []).filter(function (c) {
        return norm(c.value) === needle;
      })[0] || null
    );
  }

  /* Zdjęcia kompletów są w katalogu pod znormalizowanym kluczem (bez polskich znaków) —
     te same pliki, których używa karta produktu. */
  function bodySetImageKey(value, body) {
    var v = norm(displayValue(value));
    var p = /przod|\bfront\b/.test(v);
    var t = /tyl|\brear\b/.test(v);
    var b = /baga|\btrunks?\b|\bboots?\b/.test(v);
    var k = /kierowc|\bdriver/.test(v);
    var r1 = /1\s*rzad|first row|one row|1\s*(?:row|st\s+row)/.test(v) || /kabina|\bcab\b/.test(v);
    var r2 = /2\s*rzed|second row|two rows|2\s*(?:rows?|nd\s+row)/.test(v);
    var r3 = /3\s*r(zad|zedy)|third row|three rows|3\s*(?:rows?|rd\s+row)/.test(v);
    var large = /duzy|\blarge\b/.test(v);
    var small = /maly|\bsmall\b/.test(v);
    var whole = /cale auto|whole car|entire car/.test(v);
    var twoBags = /2\s*(?:baga|trunks?|boots?)|two\s+(trunks?|boots?)/.test(v);

    if (/^(bus|van_duzy)/.test(body)) {
      if (k) return 'kierowca';
      if (r3 && b) return large ? '3rzDuzyBag' : '3rzMalyBag';
      if (r3) return '3rz';
      if (r2 && b) return '2rzBag';
      if (r2) return '2rz';
      if ((r1 || (p && !t && !/rzed|row/.test(v))) && b) return '1rzBag';
      if (r1 || (p && !t && !/rzed|row/.test(v))) return '1rz';
      if (b) return large || !small ? 'duzyBag' : 'malyBag';
      return '1rz';
    }
    if (body === 'electro_7os' && b && (whole || /wszyst|3\s*(?:baga|trunks?|boots?)|three\s+(trunks?|boots?)/.test(v))) {
      return large ? 'caleauto-duzybag' : 'caleauto-malybag';
    }
    if (body === 'minivan') {
      if (k) return 'kierowca';
      if (whole && b) return '3rz-2bag';
      if (r3 && twoBags) return '3rz-2bag';
      if (r3 && b) return small ? '3rz-malybag' : '3rz-duzybag';
      if (r3) return '3rz';
      if (r2) return '2rz';
      if (b) return small ? 'malybag' : 'duzybag';
      return 'przod';
    }
    if (body === 'pickup') {
      if (k) return 'kierowca';
      if (p && t && b) return 'przodtyl-bagaznik';
      if (p && t) return 'przodtyl';
      if (p && b) return 'przod-bagaznik';
      if (b && !p && !t) return 'bagaznik';
      if (t && !p) return 'tyl';
      return 'przod';
    }
    if (body === 'van_maly') {
      if (k) return 'kierowca';
      if (p && b) return 'przod-bagaznik';
      if (b) return 'bagaznik';
      return 'przod';
    }
    if (body === 'tractor' || body === 'camper') return '1rz';
    if (body === 'tir') {
      if (k) return 'kierowca';
      if (/bez\s*tunel|without\s+tunnel/.test(v)) return 'bez-tunelu';
      if (/tunel|tunnel/.test(v)) return 'z-tunelem';
      if (r1) return 'bez-tunelu';
      return 'kierowca';
    }
    if (body === 'electro') {
      if (/3\s*(?:baga|trunks?|boots?)|three\s+(trunks?|boots?)/.test(v)) return 'frunk3';
      if (r1) return 'front';
      if (/^\s*2\s*rzad\b|^\s*second\s+row\b/.test(v)) return 'rear';
      if (r2 && b) return 'frontRearTrunk';
      if (r2) return 'frontRear';
    }
    if (body === '7os' || body === 'electro_7os') {
      if (k) return 'kierowca';
      if (r3 && twoBags) return 'rows123TwoTrunks';
      if (p && t && r3 && b && large) return 'rows123LargeTrunk';
      if (p && t && r3 && b) return 'rows123Trunk';
      if (p && t && r3) return 'rows123';
      if (r3 && b && large) return 'rows123LargeTrunk';
      if (r3 && b) return 'rows123Trunk';
      if (r3) return 'rows123';
      if (r2) return 'frontRear';
      if (p && t && b) return 'frontRearTrunk';
      if (p && t) return 'frontRear';
      if (b) return 'trunk';
      if (t) return 'rear';
      return 'front';
    }
    if (p && t && b) return 'frontRearTrunk';
    if (p && b) return 'frontTrunk';
    if (p && t) return 'frontRear';
    if (b && !p && !t) return 'trunk';
    if (t && !p) return 'rear';
    if (k) return 'kierowca';
    if (p) return 'front';
    return 'frontRear';
  }

  function normalizedCatalogBodyType(bodyValue, fallbackBodyValue) {
    var explicitBody = bodyValue != null && bodyValue !== '';
    var body = norm(explicitBody ? bodyValue : ((state && state.metaBodyType) || (state && state.bodyType) || '5os'));
    if (body === 'custom' || body === 'universal' || body === '5os, 7os') {
      body = norm(fallbackBodyValue || (!explicitBody && state && state.bodyType) || '5os');
    }
    if (body === 'van_duzy' || body === 'van_duzy_separate_2_row') body = 'van_duzy_separate';
    if (body === 'van_duzy_solid_2_row') body = 'van_duzy_solid';
    if (body === 'minivan_mini') body = 'minivan';
    if (body === 'pickup2kabina') body = 'pickup';
    return body;
  }

  function zestawImage(value, bodyValue, fallbackBodyValue) {
    var data = getCatalog();
    if (!data || !data.zestawImages) return null;
    var body = normalizedCatalogBodyType(bodyValue, fallbackBodyValue);
    var bodyImages = data.bodySetImages && data.bodySetImages[body];
    if (bodyImages) {
      var imageKey = bodySetImageKey(value, body);
      var bodyImage = bodyImages[imageKey];
      if (!bodyImage && body === 'electro_7os' && data.bodySetImages['7os']) {
        bodyImage = data.bodySetImages['7os'][imageKey];
      }
      if (bodyImage) return bodyImage;
    }
    var entry = data.zestawImages[norm(displayValue(value))];
    if (!entry) return null;
    var key = body.indexOf('7os') !== -1 ? '7os' : '5os';
    return entry[key] || entry['5os'] || entry['7os'] || null;
  }

  function hydrateSetSwatches(root) {
    if (!root || !root.querySelectorAll || !getCatalog()) return;
    root.querySelectorAll('[data-eva-set-swatch]').forEach(function (img) {
      var url = zestawImage(
        img.getAttribute('data-eva-set-value') || '',
        img.getAttribute('data-eva-body-type') || '',
        img.getAttribute('data-eva-body-fallback') || ''
      );
      if (!url) return;
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      img.hidden = false;
    });
  }

  function matColorsFor(shapeValue) {
    var data = getCatalog();
    var shapeKey = (shapeByValue(shapeValue) || {}).key || 'diamonds';
    return data.matColors.filter(function (c) {
      return c['for'].indexOf(shapeKey) !== -1;
    });
  }

  /* ---------- warianty ---------- */

  function optionNames(product) {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  function optionIndexes(product) {
    var names = optionNames(product);
    var typeIdx = -1;
    var setIdx = -1;
    names.forEach(function (name, i) {
      var n = norm(name);
      if (typeIdx === -1 && n.indexOf('rodzaj') !== -1) typeIdx = i;
      if (setIdx === -1 && n.indexOf('zestaw') !== -1) setIdx = i;
    });
    if (setIdx === -1 && names.length === 1) setIdx = 0;
    return { typeIdx: typeIdx, setIdx: setIdx, names: names };
  }

  function variantOption(variant, index) {
    if (index < 0) return null;
    var opts = variant.options || [];
    return opts[index] != null ? opts[index] : null;
  }

  function uniqueValues(variants, index) {
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var value = variantOption(v, index);
      if (value == null) return;
      if (seen[value]) return;
      seen[value] = true;
      out.push(value);
    });
    return out;
  }

  /* Filtr Zestaw wg typu nadwozia — jak filterZestawByBodyType() na karcie produktu.
     Stosujemy wyłącznie, gdy pozycja ma właściwość "Typ nadwozia" z 5os/7os (auta uniwersalne). */
  function bodyTypeOf(item) {
    var props = item.properties || {};
    var raw = '';
    Object.keys(props).forEach(function (key) {
      if (norm(key).indexOf('typ nadwozia') !== -1) raw = norm(props[key]);
    });
    if (raw.indexOf('7os') !== -1) return '7os';
    if (raw.indexOf('5os') !== -1) return '5os';
    return '';
  }

  function zestawAllowed(value, bodyType) {
    var data = getCatalog();
    if (!bodyType || !data || !data.zestawBody) return true;
    var needle = norm(displayValue(value));
    var inList = function (list) {
      return (list || []).some(function (entry) {
        return norm(entry) === needle;
      });
    };
    if (inList(data.zestawBody.both)) return true;
    if (inList(data.zestawBody['5os'])) return bodyType === '5os';
    if (inList(data.zestawBody['7os'])) return bodyType === '7os';
    return true;
  }

  function findVariant(product, typeValue, setValue) {
    var idx = optionIndexes(product);
    return (
      (product.variants || []).filter(function (v) {
        var typeOk = idx.typeIdx === -1 || variantOption(v, idx.typeIdx) === typeValue;
        var setOk = idx.setIdx === -1 || variantOption(v, idx.setIdx) === setValue;
        return typeOk && setOk;
      })[0] || null
    );
  }

  function availableSets() {
    var idx = optionIndexes(state.product);
    return (state.product.variants || []).filter(function (v) {
      if (!v.available) return false;
      if (idx.typeIdx !== -1 && variantOption(v, idx.typeIdx) !== state.matsType) return false;
      return zestawAllowed(variantOption(v, idx.setIdx), state.bodyType);
    });
  }

  function currentPricing() {
    var variant = findVariant(state.product, state.matsType, state.matsSet);
    if (!variant) return null;
    var shape = shapeByValue(state.shape);
    var main = variantPricing(variant, state.quantity);

    /* Dla aktualnego wariantu cart.js jest jeszcze dokladniejszym zrodlem niz
       prognoza: uwzglednia wynik funkcji rabatowej Shopify z tej konkretnej linii. */
    if (state.item && Number(state.item.variant_id) === Number(variant.id)) {
      if (state.item.original_line_price != null) main.regular = Number(state.item.original_line_price);
      if (state.item.final_line_price != null) main.final = Number(state.item.final_line_price);
    }

    var extras = shape && shape.surcharge ? shape.surcharge * state.quantity : 0;

    /* Stopka ma pokazywac cene calej edytowanej konfiguracji, nie tylko
       dywanikow. Wczesniej zaznaczenie organizera/podpietki zmienialo liste,
       ale kwota i roznica zostawaly bez zmian. */
    allAddons().forEach(function (product) {
      if (!addonOn[product.handle]) return;
      var selected = currentVariant(product);
      if (!selected) return;
      var inCart = addonInCart[product.handle];
      extras += (Number(selected.price) || 0) * (inCart && inCart.qty ? inCart.qty : 1);
    });

    return {
      regular: main.regular + extras,
      final: main.final + extras,
      savings: Math.max(0, main.regular - main.final)
    };
  }

  /* ---------- budowa arkusza ---------- */

  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'cfg-sheet';
    sheet.setAttribute('hidden', '');
    sheet.innerHTML = [
      '<div class="cfg-sheet__backdrop" data-cfg-close></div>',
      '<div class="cfg-sheet__panel" role="dialog" aria-modal="true" aria-label="' + tr('Edytuj konfigurację', 'Edit configuration') + '">',
      '  <div class="cfg-sheet__head">',
      '    <div>',
      '      <div class="cfg-sheet__title">' + tr('Edytuj konfigurację', 'Edit configuration') + '</div>',
      '      <div class="cfg-sheet__subtitle" data-cfg-product></div>',
      '    </div>',
      '    <button type="button" class="cfg-sheet__close" data-cfg-close aria-label="' + tr('Zamknij', 'Close') + '">&times;</button>',
      '  </div>',
      '  <div class="cfg-sheet__body" data-cfg-body></div>',
      '  <div class="cfg-sheet__foot">',
      '    <div class="cfg-sheet__price" data-cfg-price></div>',
      '    <div class="cfg-sheet__actions">',
      '      <button type="button" class="cfg-btn cfg-btn--ghost" data-cfg-close>' + tr('Anuluj', 'Cancel') + '</button>',
      '      <button type="button" class="cfg-btn cfg-btn--primary" data-cfg-save disabled>' + tr('Zapisz zmiany', 'Save changes') + '</button>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-cfg-close]')) {
        closeSheet();
        return;
      }
      if (e.target.closest('[data-cfg-save]')) {
        save();
        return;
      }
      if (e.target.closest('[data-step-done]')) {
        state.openStep = null;
        state.matAutoChanged = false;
        renderBody();
        return;
      }
      var toggle = e.target.closest('[data-step-toggle]');
      if (toggle) {
        var id = toggle.getAttribute('data-step-toggle');
        state.openStep = state.openStep === id ? null : id;
        state.matAutoChanged = false;
        renderBody({ scrollToOpen: true });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hasAttribute('hidden')) closeSheet();
    });
    return sheet;
  }

  function openSheet() {
    buildSheet().removeAttribute('hidden');
    document.body.classList.add('cfg-sheet-open');
  }

  /* Znacznik na <html> — po nim CSS chowa dymek czatu, gdy popup jest otwarty. */
  function oznaczOtwarcie(otwarty) {
    try { document.documentElement.classList.toggle('evm-cfg-open', !!otwarty); } catch (e) {}
  }

  function closeSheet() {
    oznaczOtwarcie(false);
    if (!sheet) return;
    sheet.setAttribute('hidden', '');
    document.body.classList.remove('cfg-sheet-open');
    state = null;
  }

  /* ---------- kroki ---------- */

  function tile(option, selected, group, size) {
    return [
      '<label class="cfg-tile' + (selected ? ' is-selected' : '') + '">',
      '  <input type="radio" name="' + group + '" value="' + escapeAttr(option.value) + '"' + (selected ? ' checked' : '') + '>',
      '  <span class="cfg-tile__img"><img src="' + option.img + '" alt="" decoding="async" width="' + size + '" height="' + size + '"></span>',
      '  <span class="cfg-tile__label">' + pretty(option.title) + (option.surcharge ? ' <em>+' + money(option.surcharge) + '</em>' : '') + '</span>',
      '</label>'
    ].join('');
  }

  /* Zwraca listę kroków: { id, label, value, img, group, html } */
  function buildSteps() {
    var data = getCatalog();
    var product = state.product;
    var idx = optionIndexes(product);
    var steps = [];

    if (idx.typeIdx !== -1) {
      var types = uniqueValues(
        (product.variants || []).filter(function (v) {
          return v.available;
        }),
        idx.typeIdx
      );
      if (types.length > 1) {
        steps.push({
          id: 'type',
          group: 'komplet',
          label: localizeUiValue(idx.names[idx.typeIdx] || 'Rodzaj dywaników'),
          value: localizeUiValue(displayValue(state.matsType)),
          img: typeImage(state.matsType),
          html:
            '<div class="cfg-list">' +
            types
              .map(function (value) {
                var selected = value === state.matsType;
                var img = typeImage(value);
                return (
                  '<label class="cfg-row' + (selected ? ' is-selected' : '') + (img ? ' cfg-row--img' : '') + '">' +
                  '<input type="radio" name="cfg-type" value="' + escapeAttr(value) + '"' + (selected ? ' checked' : '') + '>' +
                  (img ? '<span class="cfg-row__img"><img src="' + img + '" alt="" decoding="async" width="44" height="44"></span>' : '') +
                  '<span class="cfg-row__name">' + localizeUiValue(displayValue(value)) + '</span>' +
                  '</label>'
                );
              })
              .join('') +
            '</div>'
        });
      }
    }

    if (idx.setIdx !== -1) {
      var sets = availableSets();
      steps.push({
        id: 'set',
        group: 'komplet',
        label: localizeUiValue(idx.names[idx.setIdx] || 'Zestaw'),
        value: localizeUiValue(displayValue(state.matsSet)),
        img: zestawImage(state.matsSet),
        html:
          '<div class="cfg-list">' +
          sets
            .map(function (v) {
              var value = variantOption(v, idx.setIdx);
              var selected = value === state.matsSet;
              var img = zestawImage(value);
              return (
                '<label class="cfg-row' + (selected ? ' is-selected' : '') + (img ? ' cfg-row--img' : '') + '">' +
                '<input type="radio" name="cfg-set" value="' + escapeAttr(value) + '"' + (selected ? ' checked' : '') + '>' +
                (img ? '<span class="cfg-row__img"><img src="' + img + '" alt="" decoding="async" width="44" height="44"></span>' : '') +
                '<span class="cfg-row__name">' + localizeUiValue(displayValue(value)) + '</span>' +
                variantPriceHtml(v) +
                '</label>'
              );
            })
            .join('') +
          '</div>'
      });
    }

    var shapes = data.shapes.filter(function (s) {
      return s.key !== 'drop' || state.allowDrop;
    });
    var currentShape = shapeByValue(state.shape);
    steps.push({
      id: 'shape',
      group: 'material',
      label: tr('Kształt komórek', 'Cell pattern'),
      value: pretty(currentShape ? currentShape.title : displayValue(state.shape)),
      img: currentShape ? currentShape.img : null,
      note: currentShape && currentShape.surcharge ? '+' + money(currentShape.surcharge) : '',
      html:
        '<div class="cfg-tiles cfg-tiles--wide">' +
        shapes
          .map(function (s) {
            return tile(s, norm(s.value) === norm(state.shape), 'cfg-shape', 72);
          })
          .join('') +
        '</div>'
    });

    var mats = matColorsFor(state.shape);
    var currentMat = colorByValue(data.matColors, state.mat);
    steps.push({
      id: 'mat',
      group: 'material',
      label: tr('Kolor materiału', 'Mat colour'),
      value: pretty(currentMat ? currentMat.title : displayValue(state.mat)),
      img: currentMat ? currentMat.img : null,
      html:
        (state.matAutoChanged
          ? '<p class="cfg-note">' + (IS_EN
            ? 'The colour “' + localizeUiValue(displayValue(state.matPrevious)) + '” is not available for the “' + localizeUiValue(currentShape ? currentShape.title : state.shape) + '” pattern. We selected ' + localizeUiValue(currentMat ? currentMat.title : state.mat).toLowerCase() + ' — you can choose another colour.'
            : 'Kolor „' + displayValue(state.matPrevious) + '” nie występuje w kształcie „' + (currentShape ? currentShape.title : state.shape) + '”. Ustawiliśmy ' + (currentMat ? currentMat.title.toLowerCase() : state.mat) + ' — możesz wybrać inny.') + '</p>'
          : '') +
        '<div class="cfg-tiles">' +
        mats
          .map(function (c) {
            return tile(c, norm(c.value) === norm(state.mat), 'cfg-mat', 56);
          })
          .join('') +
        '</div>'
    });

    var currentTrim = colorByValue(data.trimColors, state.trim);
    steps.push({
      id: 'trim',
      group: 'material',
      label: tr('Kolor obszycia', 'Trim colour'),
      value: pretty(currentTrim ? currentTrim.title : displayValue(state.trim)),
      img: currentTrim ? currentTrim.img : null,
      html:
        '<div class="cfg-tiles">' +
        data.trimColors
          .map(function (c) {
            return tile(c, norm(c.value) === norm(state.trim), 'cfg-trim', 56);
          })
          .join('') +
        '</div>'
    });

    /* 02.10 właściciel: wycieraczki i inne produkty «corners» — bez podpiętki i dodatków */
    var noAddons = !!(state && norm(state.metaBodyType || '') === 'corners');

    if (!noAddons && ADDONS.podpietki && ADDONS.podpietki.length) {
      steps.push({
        id: 'podpietka',
        group: 'dodatki',
        label: tr('Podpiętka', 'Heel pad'),
        value: pickedPodpietkaProduct() ? localizeUiValue(pickedPodpietkaProduct().title) : tr('Nie wybrano', 'Not selected'),
        html:
          '<div class="cfg-list">' +
          ADDONS.podpietki.map(function (p) {
            return addonRow(p, 'cfg-podpietka', 'checkbox');
          }).join('') +
          '</div>'
      });
    }

    if (!noAddons && ADDONS.dodatki && ADDONS.dodatki.length) {
      var dCount = pickedDodatkiProducts().length;
      steps.push({
        id: 'dodatki',
        group: 'dodatki',
        label: tr('Dodatki', 'Extras'),
        value: dCount ? dCount + (dCount === 1 ? tr(' pozycja', ' item') : tr(' pozycje', ' items')) : tr('Nie wybrano', 'Not selected'),
        html:
          '<div class="cfg-list">' +
          ADDONS.dodatki.map(function (p) {
            return addonRow(p, 'cfg-dodatek', 'checkbox');
          }).join('') +
          '</div>'
      });
    }

    return steps;
  }

  function groupLabel(group) {
    var labels = {
      komplet: tr('Komplet', 'Set'),
      material: tr('Materiał', 'Material'),
      dodatki: tr('Podpiętka i dodatki', 'Heel pad and extras')
    };
    return labels[group] || '';
  }

  var PENCIL =
    '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M13.2 3.3l3.5 3.5M4 16.5l3.9-.8 8.1-8.1a1.6 1.6 0 0 0 0-2.3l-1.3-1.3a1.6 1.6 0 0 0-2.3 0L4.3 12l-.8 3.9a.5.5 0 0 0 .5.6z"/>' +
    '</svg>';

  function renderBody(options) {
    options = options || {};
    var body = sheet.querySelector('[data-cfg-body]');
    var scrollTop = body.scrollTop;
    var steps = buildSteps();
    state.steps = steps;

    var html = [];
    var lastGroup = null;
    steps.forEach(function (step) {
      if (step.group !== lastGroup) {
        lastGroup = step.group;
        html.push('<div class="cfg-groupline">' + groupLabel(step.group) + '</div>');
      }
      var open = state.openStep === step.id;
      html.push('<section class="cfg-step' + (open ? ' is-open' : '') + (step.img ? '' : ' cfg-step--plain') + '" data-step="' + step.id + '">');
      html.push(
        '<button type="button" class="cfg-step__head" data-step-toggle="' + step.id + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
          (step.img
            ? '<span class="cfg-step__sample"><img src="' + step.img + '" alt="" decoding="async" width="34" height="34"></span>'
            : '') +
          '<span class="cfg-step__text">' +
            '<span class="cfg-step__label">' + step.label + '</span>' +
            '<span class="cfg-step__value">' + step.value + (step.note ? ' <em>' + step.note + '</em>' : '') + '</span>' +
          '</span>' +
          '<span class="cfg-step__edit" aria-hidden="true">' + PENCIL + '</span>' +
        '</button>'
      );
      html.push(
        '<div class="cfg-step__panel">' +
          (open
            ? step.html +
              '<div class="cfg-step__confirm">' +
                '<button type="button" class="cfg-btn cfg-btn--step" data-step-done>' + tr('Gotowe', 'Done') + '</button>' +
              '</div>'
            : '') +
        '</div>'
      );
      html.push('</section>');
    });

    body.innerHTML = html.join('');
    body.scrollTop = scrollTop;
    if (options.scrollToOpen) {
      var openEl = body.querySelector('.cfg-step.is-open');
      if (openEl) {
        var delta = openEl.offsetTop - body.scrollTop;
        if (delta < 0 || delta > body.clientHeight - 120) {
          body.scrollTo({ top: Math.max(0, openEl.offsetTop - 8), behavior: 'smooth' });
        }
      }
    }
    renderPrice();
  }

  function renderPrice() {
    var el = sheet.querySelector('[data-cfg-price]');
    var saveBtn = sheet.querySelector('[data-cfg-save]');
    var pricing = currentPricing();
    if (pricing == null) {
      el.innerHTML = '<span class="cfg-price__err">' + tr('Tego zestawu nie ma w tej chwili w sprzedaży', 'This set is currently unavailable') + '</span>';
      saveBtn.disabled = true;
      return;
    }
    saveBtn.disabled = false;
    var diff = pricing.final - state.initialTotal;
    el.innerHTML =
      '<span class="cfg-price__label">' + (pricing.savings ? tr('Konfiguracja po rabacie', 'Configuration after discount') : tr('Konfiguracja', 'Configuration')) + '</span>' +
      (pricing.savings ? '<s class="cfg-price__old">' + money(pricing.regular) + '</s>' : '') +
      '<span class="cfg-price__value">' + money(pricing.final) + '</span>' +
      (pricing.savings ? '<span class="cfg-price__saving">' + tr('Oszczędzasz ', 'You save ') + money(pricing.savings) + '</span>' : '') +
      (diff
        ? '<span class="cfg-price__diff' + (diff > 0 ? ' is-up' : ' is-down') + '">' + (diff > 0 ? '+' : '−') + money(Math.abs(diff)) + (IS_EN ? ' vs current configuration' : ' względem obecnej') + '</span>'
        : '');
  }

  function onChange(e) {
    if (!state || !sheet || sheet.hasAttribute('hidden')) return;
    var input = e.target;
    if (!input.name || input.name.indexOf('cfg-') !== 0) return;

    if (input.name === 'cfg-type') {
      state.matsType = input.value;
      var idx = optionIndexes(state.product);
      var stillOk = findVariant(state.product, state.matsType, state.matsSet);
      if (!stillOk || !stillOk.available) {
        var first = availableSets()[0];
        if (first) state.matsSet = variantOption(first, idx.setIdx);
      }
      state.openStep = 'type';
    } else if (input.name === 'cfg-set') {
      state.matsSet = input.value;
      state.openStep = 'set';
    } else if (input.name === 'cfg-shape') {
      state.shape = input.value;
      var allowed = matColorsFor(state.shape);
      var ok = allowed.some(function (c) {
        return norm(c.value) === norm(state.mat);
      });
      state.matAutoChanged = false;
      if (!ok && allowed.length) {
        state.matPrevious = state.mat;
        state.mat = allowed[0].value;
        state.matAutoChanged = true;
      }
      state.openStep = 'shape';
    } else if (input.name === 'cfg-mat') {
      state.mat = input.value;
      state.matAutoChanged = false;
      state.openStep = 'mat';
    } else if (input.name === 'cfg-trim') {
      state.trim = input.value;
      state.openStep = 'trim';
    } else if (input.name === 'cfg-podpietka') {
      /* Mozna wziac kilka podpietek, ale ZAMONTOWANA tylko jedna — montaz robimy
         w jednym auciе. Przy wyborze drugiej zamontowanej pierwsza cicho wraca
         do „Niezamontowana” i odchodzi jej doplata 10 zl. */
      if (addonOn[input.value]) delete addonOn[input.value];
      else addonOn[input.value] = true;
      state.openStep = 'podpietka';
    } else if (input.name === 'cfg-dodatek') {
      if (addonOn[input.value]) delete addonOn[input.value];
      else addonOn[input.value] = true;
      state.openStep = 'dodatki';
    } else if (input.name.indexOf('cfg-opt::') === 0) {
      var parts = input.name.split('::');
      var oi = parseInt(parts[parts.length - 1], 10);
      var hnd = parts.slice(1, parts.length - 1).join('::');
      var prod = allAddons().filter(function (x) { return x.handle === hnd; })[0];
      if (prod) {
        var vals = valuesOf(prod).slice();
        vals[oi] = input.value;
        /* gdy taka kombinacja nie istnieje — dociagamy reszte opcji do najblizszej */
        var res = variantFor(prod, vals);
        addonSel[hnd] = (res.opts && res.opts.length) ? res.opts.slice() : vals;
        /* Wybrano „Zamontowana” — pozostale podpietki wracaja do niezamontowanych. */
        if (jestZamontowana(prod, addonSel[hnd])) odmontujPozostale(hnd);
        state.openStep = (ADDONS.podpietki || []).some(function (x) { return x.handle === hnd; }) ? 'podpietka' : 'dodatki';
      }
    }

    /* wybór tylko zaznacza — krok zamyka dopiero „Gotowe”.
       renderBody przerysowuje cala liste, wiec bez zapamietania pozycji
       przewijania popup „skakal” po kazdym kliknieciu w dodatek. */
    var body3 = sheet.querySelector('[data-cfg-body]');
    var zapamietanyScroll = body3 ? body3.scrollTop : 0;
    renderBody();
    if (body3) body3.scrollTop = zapamietanyScroll;
  }

  /* ---------- otwarcie / zapis ---------- */

  function open(row) {
    var key = row.getAttribute('data-line-key');
    var handle = row.getAttribute('data-product-handle');
    if (!key || !handle || !getCatalog()) return;

    openSheet();
    var body = sheet.querySelector('[data-cfg-body]');
    var readyButton = sheet.querySelector('[data-cfg-save]');
    if (readyButton) readyButton.disabled = true;
    body.innerHTML = '<div class="cfg-loading">' + tr('Wczytywanie opcji…', 'Loading options…') + '</div>';
    sheet.querySelector('[data-cfg-price]').innerHTML = '';
    sheet.querySelector('[data-cfg-product]').textContent = row.getAttribute('data-product-title') || '';

    /* cart-cro-actions utrzymuje aktualny obiekt koszyka po kazdej mutacji.
       Uzywamy go przy otwarciu edytora, zamiast pobierac identyczne /cart.js;
       zapytanie zostaje jako bezpieczny fallback po bezposrednim wejściu. */
    var cachedCart = window.__evmCartState;
    var cartRequest = cachedCart && Array.isArray(cachedCart.items)
      ? Promise.resolve(cachedCart)
      : getJSON('/cart.js');
    Promise.all([cartRequest, getJSON('/products/' + handle + '.js')])
      .then(function (res) {
        var cart = res[0];
        var product = res[1];
        var item = cart.items.filter(function (i) {
          return i.key === key;
        })[0];
        if (!item) throw new Error(tr('Nie znaleziono pozycji w koszyku', 'Cart item not found'));
        var myCfg = item.properties && item.properties._config_id;
        syncAddonsFromCart(cart, myCfg);

        var idx = optionIndexes(product);
        var current = (product.variants || []).filter(function (v) {
          return v.id === item.variant_id;
        })[0];

        state = {
          item: item,
          product: product,
          quantity: item.quantity,
          bodyType: bodyTypeOf(item),
          allowDrop: row.getAttribute('data-allow-drop') === 'true',
          metaBodyType: row.getAttribute('data-body-type') || '',
          matsType: current ? variantOption(current, idx.typeIdx) : null,
          matsSet: current ? variantOption(current, idx.setIdx) : null,
          shape: item.properties[PROP_SHAPE] || 'romby',
          mat: item.properties[PROP_MAT] || 'czarny',
          trim: item.properties[PROP_TRIM] || 'czarny',
          matAutoChanged: false,
          matPrevious: null,
          /* slot „Podpietka / Dodatki” w karcie prosi o konkretna sekcje */
          openStep: pendingStep,
          steps: []
        };
        var otworzonyZeSlotu = !!pendingStep;
        pendingStep = null;
        var initialPricing = currentPricing();
        state.initialTotal = initialPricing ? initialPricing.final : 0;
        oznaczOtwarcie(true);
        renderBody();
        if (readyButton) readyButton.disabled = false;
        /* Klient kliknal „Podpiętka” w karcie — popup ma go tam od razu zabrac,
           a nie zaczynac od gory listy. Sekcja jest juz rozwinieta, brakowalo
           tylko przewiniecia; po pierwszym rysowaniu wysokosci sa juz znane. */
        if (otworzonyZeSlotu && state.openStep) {
          requestAnimationFrame(function () {
            var body2 = sheet.querySelector('[data-cfg-body]');
            var el = body2 && body2.querySelector('.cfg-step.is-open');
            if (el) body2.scrollTo({ top: Math.max(0, el.offsetTop - 8), behavior: 'auto' });
          });
          setTimeout(function () {
            var body2 = sheet.querySelector('[data-cfg-body]');
            var el = body2 && body2.querySelector('.cfg-step.is-open');
            if (el) body2.scrollTo({ top: Math.max(0, el.offsetTop - 8), behavior: 'auto' });
          }, 120);
        }
      })
      .catch(function (err) {
        console.error('[cart-config-edit]', err);
        body.innerHTML = '<div class="cfg-loading cfg-loading--err">' + tr('Nie udało się wczytać konfiguracji. Odśwież stronę i spróbuj ponownie.', 'The configuration could not be loaded. Refresh the page and try again.') + '</div>';
      });
  }

  function save() {
    if (!state) return;
    var variant = findVariant(state.product, state.matsType, state.matsSet);
    if (!variant) return;

    var saveBtn = sheet.querySelector('[data-cfg-save]');
    saveBtn.disabled = true;
    saveBtn.textContent = IS_EN ? 'SAVING…' : 'Zapisywanie…';

    /* Starsza pozycja mogla trafic do koszyka bez identyfikatora grupy. Przy
       jednym komplecie heurystyka Liquid to maskowala, ale przy dwoch nowa
       podpietka stawala sie osobna karta. Pierwszy zapis edytora migruje taki
       komplet do jednoznacznej grupy i od razu uzywa jej dla dodatkow. */
    var myCfgId = state.item.properties && state.item.properties._config_id;
    if (!myCfgId) myCfgId = createConfigId();

    var props = cleanProps(Object.assign({}, state.item.properties));
    props._config_id = myCfgId;
    props._role = 'main';
    props[PROP_SHAPE] = state.shape;
    props[PROP_MAT] = state.mat;
    props[PROP_TRIM] = state.trim;

    /* Dodatki uzgadniamy z koszykiem: dodaj brakujace, PODMIEN gdy zmienil sie
       wariant, usun odznaczone. Nigdy nie dokladamy drugiej takiej samej pozycji. */
    /* Dodatek dodany z koszyka nalezy do tego samego kompletu co edytowana
       pozycja — inaczej po zapisie zostalby sierota bez przypisania. */
    function addonProps(p) {
      var isHeel = (ADDONS.podpietki || []).some(function (x) { return x.handle === p.handle; });
      return { _config_id: myCfgId, _role: isHeel ? 'heel' : 'extra' };
    }
    var addonOps = [];
    allAddons().forEach(function (p) {
      var want = !!addonOn[p.handle];
      var have = addonInCart[p.handle];
      var wantId = want ? currentVariant(p).id : null;
      if (want && !have) addonOps.push({ add: { id: wantId, quantity: 1, properties: addonProps(p) } });
      else if (want && have && have.id !== wantId) addonOps.push({ dropKey: have.key, dropVariant: have.id, add: { id: wantId, quantity: have.qty || 1, properties: addonProps(p) } });
      else if (!want && have) addonOps.push({ dropKey: have.key, dropVariant: have.id });
    });
    function runAddonOps() {
      return addonOps.reduce(function (chain, op) {
        return chain.then(function () {
          var drop = op.dropKey
            ? getJSON('/cart.js').then(function (cart) {
                var found = findCartItem(cart, { key: op.dropKey, variantId: op.dropVariant });
                if (!found) return cart;
                return changeLine(found.line, 0);
              })
            : Promise.resolve();
          return op.add ? drop.then(function () { return postJSON('/cart/add.js', { items: [op.add] }); }) : drop;
        });
      }, Promise.resolve());
    }

    getJSON('/cart.js')
      .then(function (cart) {
        var found = findCartItem(cart, {
          key: state.item.key,
          configId: myCfgId,
          variantId: state.item.variant_id
        });
        if (!found) throw new Error(tr('Nie znaleziono pozycji w koszyku', 'Cart item not found'));
        var sameVariant = Number(variant.id) === Number(found.item.variant_id);
        if (sameVariant) {
          return changeLine(found.line, state.quantity, props);
        }
        return changeLine(found.line, 0).then(function () {
          return postJSON('/cart/add.js', {
            items: [{ id: variant.id, quantity: state.quantity, properties: props }]
          });
        });
      })
      .then(function (cartPoProdukcie) {
        return runAddonOps().then(function (cartPoDodatkach) {
          var wynik = addonOps.length ? cartPoDodatkach : cartPoProdukcie;
          return wynik && typeof wynik.item_count === 'number'
            ? wynik
            : getJSON('/cart.js');
        });
      })
      .then(function (cart) {
        var position = -1;
        cart.items.forEach(function (item, i) {
          if (position !== -1) return;
          if (item.variant_id !== variant.id) return;
          var p = item.properties || {};
          if (norm(p[PROP_SHAPE]) === norm(props[PROP_SHAPE]) && norm(p[PROP_MAT]) === norm(props[PROP_MAT]) && norm(p[PROP_TRIM]) === norm(props[PROP_TRIM])) {
            position = i;
          }
        });
        var cartItems = document.querySelector('cart-items');
        closeSheet();
        /* updateQuantity motywu dosynchronizuje dopłatę za Krople oraz przerysuje sekcje */
        if (cartItems && position !== -1) {
          return cartItems.updateQuantity(position + 1, cart.items[position].quantity);
        }
        /* Rzadki fallback (np. sekcja koszyka zostala podmieniona w trakcie zapisu):
           odswiezamy te same sekcje w tle, bez nawigacji calej strony. */
        return window.evmOdswiezKoszyk ? window.evmOdswiezKoszyk() : null;
      })
      .then(function () {
        toast(tr('Konfiguracja zaktualizowana', 'Configuration updated'));
      })
      .catch(function (err) {
        console.error('[cart-config-edit]', err);
        toast(tr('Nie udało się zapisać zmian', 'Changes could not be saved'), true);
      })
      .then(function () {
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = IS_EN ? 'SAVE CHANGES' : 'Zapisz zmiany';
        }
      });
  }

  function toast(message, isError) {
    var el = document.createElement('div');
    el.className = 'cfg-toast' + (isError ? ' cfg-toast--err' : '');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () {
        el.remove();
      }, 350);
    }, 2600);
  }

  /* Krzyzyk przy dodatku usuwa jedna linie i przerysowuje koszyk w tle.
     Migawke przekazujemy od razu do wspolnego paska „Cofnij”, wiec nie trzeba
     juz przenosic jej przez sessionStorage ani przeladowywac strony. */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-addon-remove]');
    if (!x) return;
    e.preventDefault();
    e.stopPropagation();
    x.disabled = true;
    var klucz = x.getAttribute('data-addon-remove');
    var doPrzywrocenia = null;
    getJSON('/cart.js').then(function (cart) {
      var it = (cart.items || []).filter(function (i) { return i.key === klucz; })[0];
      if (it) {
        var props = {};
        Object.keys(it.properties || {}).forEach(function (k) {
          if (it.properties[k] !== null && it.properties[k] !== '') props[k] = it.properties[k];
        });
        doPrzywrocenia = {
          id: it.variant_id,
          quantity: it.quantity,
          properties: props,
          title: it.product_title
        };
      }
      return postJSON('/cart/change.js', { id: klucz, quantity: 0 });
    })
      .then(function (cart) {
        return window.evmOdswiezKoszyk ? window.evmOdswiezKoszyk(cart) : null;
      })
      .then(function () {
        if (!doPrzywrocenia) return;
        document.dispatchEvent(new CustomEvent('evm:skasowano-grupe', {
          detail: { linie: [doPrzywrocenia] }
        }));
      })
      .catch(function (err) {
        console.error('[cart-config-edit]', err);
        if (window.evmPokazBladKoszyka) window.evmPokazBladKoszyka();
        else toast(tr('Nie udało się zaktualizować koszyka. Spróbuj ponownie.', 'The cart could not be updated. Please try again.'), true);
        x.disabled = false;
      });
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-config-edit]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-line-key]');
    /* slot „Podpietka / Dodatki” otwiera popup od razu na swojej sekcji */
    pendingStep = btn.getAttribute('data-open-step') || null;
    if (row) open(row);
  });

  document.addEventListener('change', onChange);

  hydrateSetSwatches(document);
  if (window.MutationObserver && document.body) {
    var hydrateQueued = false;
    new MutationObserver(function (mutations) {
      var hasSetSwatch = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches('[data-eva-set-swatch]') ||
            node.querySelector && node.querySelector('[data-eva-set-swatch]')
          );
        });
      });
      if (!hasSetSwatch || hydrateQueued) return;
      hydrateQueued = true;
      requestAnimationFrame(function () {
        hydrateQueued = false;
        hydrateSetSwatches(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
